import { render } from "./index.vue?vue&type=template&id=74745138&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=74745138&lang=less&scoped=true"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74745138"]])

export default __exports__